import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router";

/**
 * Nach oben scrollen, wenn eine andere Seite geöffnet wird (SICHT-CREATOR-01): ohne das behielt die neue Seite die Scrollposition
 * der alten und öffnete mitten im Inhalt. Ausgenommen sind Zurück/Vor (der Browser stellt die Position selbst her), Sprünge zu
 * einem Anker (#provision) und Wechsel nur der Abfrage (?rechnung=…, Filter), bei denen man auf derselben Seite bleibt.
 */
export function shouldScrollToTop(prevPath: string | null, next: { pathname: string; hash: string }, navigationType: string): boolean {
  if (prevPath === null) return false;
  if (navigationType === "POP") return false;
  if (next.hash) return false;
  return prevPath !== next.pathname;
}

/** Zuletzt gezeigter Pfad, über alle Rahmen hinweg (beim Wechsel z. B. von /anmelden nach /agentur wird der Rahmen neu gebaut). */
let lastPath: string | null = null;

/** In jedem Rahmen (Portal, Website-Seiten, öffentliche Seiten) einmal eingebunden. */
export function ScrollToTop(): null {
  const location = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (shouldScrollToTop(lastPath, location, navigationType) && typeof window !== "undefined") window.scrollTo(0, 0);
    lastPath = location.pathname;
  }, [location, navigationType]);
  return null;
}
